import React, { useEffect, useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import MultiLargeFileUploads from '../../components/modal/MultiLargeFileUploads';
import styles from './WESContent.module.css';
import { utils, writeFile, write } from "xlsx";
import { saveAs } from 'file-saver';

//컴포넌트
import PairedSampleList from '../../components/modal/PairedSampleList';
import downloadIcon from '../../img/common/downloadIcon.png';
import uploadIcon from '../../img/icon/uploadIconOrange.png';
import upArrowGray from '../../img/icon/upArrowGray.png';
import downArrowGray from '../../img/icon/downArrowGray.png';
import filterImage from '../../img/common/filter.png';
import upTriangleRed from '../../img/icon/upTriangleRed.png';
import ReportModal from '../../components/modal/ReportModal';

const TABS = {
    0: 'Lung',
    1: 'Gastric',
    2: 'Colon',
    3: 'Pancreas',
    4: 'Ovary',
    // 5: 'Bladder',
    6: 'Breast',
};

function WESContent({ initialSearch }) {
    const tokenValue = "ya29.A0ATkoCc64uLiMLZXbp08c42hlZxsX_dDVIP3huE5iwC3Q4WQVLUh1TOCWnrKqsNlT1e8EouKSsJDS0RDw-gR5O635QQ31p0NxaOFtNBfh6HSWuau9E7YX2AHvliRq263lkDfeS1lpnfCMlIILEFiwyD5Zj4M0-mKoA_jYRvgzch-GHoWa88bhn9C3bId8yl2RIVHVaB4rI6053DA3zYAM1VQHbvz6_sIx502Yfmlk9fxKFmSOi4OZbkhRRQT9vbAknRAQEdQKloAm-nD_6cdY0ZoJv1RqZ3oaCgYKAb0SARYSFQHGX2Mi236khwDSq4NvuVKrCKwfoQ0294"
    const storedUserInfo = JSON.parse(localStorage.getItem('userInfo'));
    const [isReportModalOpen, setIsReportModalOpen] = useState(false);
    const [selectedReportSample, setSelectedReportSample] = useState(null);
    // 리포트 팝업 열기 함수
    const handleOpenReport = (sampleName) => {
        setSelectedReportSample(sampleName);
        setIsReportModalOpen(true);
    };
    const { t } = useTranslation();
    const [mappingSummaryList, setMappingSummaryList] = useState([]);
    const [filterText, setFilterText] = useState(initialSearch || '');
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [isDownloadingCNV, setIsDownloadingCNV] = useState(false);
    const [isDownloadingMutation, setIsDownloadingMutation] = useState(false);
    const [isDownloadingPurity, setIsDownloadingPurity] = useState(false);
    const [showUploadModal, setShowUploadModal] = useState(false);
    const [activeTab, setActiveTab] = useState(0);
    const [isAllSelected, setIsAllSelected] = useState(false);
    const [keywordFilters, setKeywordFilters] = useState({
        all: true,
        NT: false,
        TT: false,
        TO: false,
        NO: false,
    });
    const showGermlineButton = ["1", "4", "6"].includes(String(activeTab));
    const [isDownloadingGermline, setIsDownloadingGermline] = useState(false);

    // 페어 리스트 상태값
    const [showPairedModal, setShowPairedModal] = useState(false);
    const [pairedSample, setPairedSample] = useState(null);

    // 샘플 클릭 핸들러
    const handleSampleClick = (sampleName) => {
        setPairedSample(sampleName);
        setShowPairedModal(true);
    };

    // ESC 키로 모달 닫기
    useEffect(() => {
        if (!showPairedModal) return;               // 모달이 열려 있을 때만 리스너 등록
        const handleKeyDown = (e) => {
            if (e.key === 'Escape') {
                setShowPairedModal(false);
            }
        };
        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [showPairedModal]);

    // ★ [추가] initialSearch가 있을 때 탭 자동 선택 로직
    useEffect(() => {
        if (initialSearch && initialSearch.length >= 3) {
            // NGS 코드의 3번째 글자 (인덱스 2) 추출하여 숫자로 변환
            // 예: G003016... -> '0' (인덱스 2) -> 0
            const tabKey = parseInt(initialSearch.charAt(2), 10);

            // 유효한 탭 번호인지 확인 (TABS 객체에 있는지)
            if (!isNaN(tabKey) && TABS[tabKey]) {
                setActiveTab(tabKey);
            }
        }
    }, [initialSearch]);

    // 페이지네이션 상태
    const [currentPage, setCurrentPage] = useState(1);
    const [currentPageInput, setCurrentPageInput] = useState('');
    const itemsPerPage = 15;

    // 정렬 상태: key는 정렬할 필드, order는 'desc', 'asc', 또는 null(원본 순서)
    const [sortConfig, setSortConfig] = useState({ key: null, order: null });

    // const itemsPerPage = 10;
    const [pageSize, setPageSize] = useState(15);

    // mapping summary 데이터는 마운트 시 한 번만 호출
    useEffect(() => {
        fetch('/api/getWESMappingSummary', { method: 'GET' })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error, status = ${response.status}`);
                }
                return response.json();
            })
            .then(data => {
                if (data) {
                    setMappingSummaryList(data);
                }
            })
            .catch(error => console.log(error));
    }, []);

    const handleCheckboxChange = (sampleName) => {
        setSelectedFiles(prev =>
            prev.includes(sampleName)
                ? prev.filter(name => name !== sampleName)
                : [...prev, sampleName]
        );
    };

    const handleTabChange = (tabKey) => {
        setActiveTab(tabKey);
        setSelectedFiles([]);
        setIsAllSelected(false);
        setCurrentPage(1);
    };

    const handleKeywordFilterChange = (key) => {
        setKeywordFilters(prev => {
            const newFilters = { ...prev };
            if (key === 'all') {
                newFilters.all = true;
                newFilters.NT = false;
                newFilters.TT = false;
                newFilters.TO = false;
                newFilters.NO = false;
            } else {
                newFilters[key] = !prev[key];
                if (newFilters.NT || newFilters.TT || newFilters.TO || newFilters.NO) {
                    newFilters.all = false;
                } else {
                    newFilters.all = true;
                }
            }
            return newFilters;
        });
    };

    // 필터링: activeTab, filterText, keywordFilters에 따라 mappingSummaryList를 필터링
    // 그룹 분류 함수 (sampleName의 8번째 자리 기준)
    const getSampleGroup = (sampleName) => {
        if (!sampleName || sampleName.length < 8) return "";
        const groupCode = sampleName.substr(7, 2).toLowerCase();
        if (["nt", "nb", "np"].includes(groupCode)) return "NT";
        else if (["tt", "tf"].includes(groupCode)) return "TT";
        else if (["to", "te"].includes(groupCode)) return "TO";
        else if (groupCode === "no") return "NO";
        else if (sampleName.charAt(7).toLowerCase() === 't') return "TT"; // 그 외 T로 시작하면 TT로 분류
        else return "";
    };

    const filteredMappingSummaryList = useMemo(() => {
        // 우선, 활성화된 그룹 필터들을 모읍니다.
        const activeGroups = [];
        if (keywordFilters.NT) activeGroups.push("NT");
        if (keywordFilters.TT) activeGroups.push("TT");
        if (keywordFilters.TO) activeGroups.push("TO");
        if (keywordFilters.NO) activeGroups.push("NO");

        return mappingSummaryList.filter(item => {
            // 탭 필터: sampleName의 3번째 문자(0-indexed: charAt(2))가 activeTab과 동일해야 함
            const tabKey = parseInt(item.sampleName.charAt(2), 10);
            if (tabKey !== activeTab) return false;

            // 텍스트 필터
            const lowerFilterText = filterText.toLowerCase();
            // item.orderNumber가 null일 수 있으므로 기본값을 빈 문자열("")로 처리
            const orderNumberText = item.orderNumber ? item.orderNumber.toLowerCase() : "";
            if (
                !item.sampleName.toLowerCase().includes(lowerFilterText) &&
                !orderNumberText.includes(lowerFilterText)
            ) {
                return false;
            }

            // 전체보기(all) 필터가 활성화되어 있으면 추가 조건 없이 모두 포함
            if (keywordFilters.all) return true;

            // sampleName 기준 그룹 분류
            const group = getSampleGroup(item.sampleName);
            // 활성화된 그룹(activeGroups)에 해당 샘플의 그룹이 포함되어야 함.
            return activeGroups.includes(group);
        });
    }, [mappingSummaryList, activeTab, filterText, keywordFilters]);

    // ★★ 클라이언트에서 엑셀 파일 생성하여 다운로드하는 함수 ★★
    const handleDownloadMappingSummary = (downloadType) => {
        let dataToDownload = [];
        if (downloadType === 'all') {
            // 현재 탭에 대한 전체 필터링된 데이터
            dataToDownload = filteredMappingSummaryList;
        } else if (downloadType === 'selected') {
            // 선택된 샘플에 해당하는 데이터 (필터링된 목록 기준)
            dataToDownload = filteredMappingSummaryList.filter(item =>
                selectedFiles.includes(item.sampleName)
            );
        }
        if (dataToDownload.length === 0) {
            alert(t('다운로드할 데이터가 없습니다.'));
            return;
        }

        // JSON 데이터를 엑셀 워크시트로 변환
        const worksheet = utils.json_to_sheet(dataToDownload);
        const workbook = utils.book_new();
        utils.book_append_sheet(workbook, worksheet, 'Sheet1');

        const currentDate = new Date().toISOString().slice(0, 10).replace(/-/g, '');
        const tabName = TABS[activeTab] || 'RNA';
        const fileName = `WES_${tabName}_mappingsummary_${currentDate}.xlsx`;

        const excelBuffer = write(workbook, { bookType: 'xlsx', type: 'array' });
        const dataBlob = new Blob([excelBuffer], { type: 'application/octet-stream' });
        saveAs(dataBlob, fileName);
    };

    const handleSelectAll = () => {
        const filteredSamples = filteredMappingSummaryList.map(item => item.sampleName);

        if (isAllSelected) {
            setSelectedFiles(prev => prev.filter(name => !filteredSamples.includes(name)));
        } else {
            setSelectedFiles(prev => [...new Set([...prev, ...filteredSamples])]);
        }

        setIsAllSelected(!isAllSelected);
    };
    useEffect(() => {
        const filteredSamples = filteredMappingSummaryList.map(item => item.sampleName);
        const isAllFilteredSelected = filteredSamples.every(sample => selectedFiles.includes(sample));

        setIsAllSelected(isAllFilteredSelected);
    }, [selectedFiles, filteredMappingSummaryList]);

    // 🔽 정렬 공통 유틸
    const isEmpty = (v) =>
        v === null || v === undefined || (typeof v === 'string' && v.trim() === '');

    const toNumberIfNumericLike = (v) => {
        if (typeof v === 'number') return v;
        if (typeof v === 'string') {
            // %, 콤마, 공백 제거 후 숫자 파싱
            const cleaned = v.replace(/[%,\s]/g, '');
            if (cleaned !== '' && !isNaN(cleaned)) return parseFloat(cleaned);
        }
        return null; // 숫자 아님
    };

    const compareWithNullLast = (a, b, order = 'asc') => {
        // 둘 다 비었으면 동일
        if (isEmpty(a) && isEmpty(b)) return 0;
        // 하나만 비었으면 빈값을 항상 뒤로
        if (isEmpty(a)) return 1;
        if (isEmpty(b)) return -1;

        // 숫자처럼 보이면 숫자로 비교
        const aNum = toNumberIfNumericLike(a);
        const bNum = toNumberIfNumericLike(b);
        if (aNum !== null && bNum !== null) {
            return order === 'asc' ? aNum - bNum : bNum - aNum;
        }

        // 문자열 비교 (대소문자 무시, 숫자 인식)
        const res = String(a).localeCompare(String(b), undefined, {
            numeric: true,
            sensitivity: 'base',
        });
        return order === 'asc' ? res : -res;
    };

    // 🔽 정렬: 모든 컬럼 공통 적용
    const sortedMappingSummaryList = useMemo(() => {
        const list = [...filteredMappingSummaryList];
        const { key, order } = sortConfig;
        if (!key || !order) return list;

        list.sort((rowA, rowB) => compareWithNullLast(rowA[key], rowB[key], order));
        return list;
    }, [filteredMappingSummaryList, sortConfig]);

    // 페이지네이션
    const totalPages = Math.ceil(sortedMappingSummaryList.length / itemsPerPage);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = sortedMappingSummaryList.slice(indexOfFirstItem, indexOfLastItem);

    // 필터링/정렬 후 totalPages가 줄어들면 currentPage를 보정
    useEffect(() => {
        // totalPages가 0일 땐 1페이지로 초기화
        const safePage = totalPages > 0 ? totalPages : 1;
        if (currentPage > safePage) {
            setCurrentPage(safePage);
        }
    }, [totalPages]);

    const handlePageChange = (newPage) => {
        if (newPage < 1 || newPage > totalPages) return;
        setCurrentPage(newPage);
    };

    const handlePageJump = () => {
        const newPage = parseInt(currentPageInput, 10);
        if (!isNaN(newPage) && newPage >= 1 && newPage <= totalPages) {
            setCurrentPage(newPage);
        } else {
            alert(t('유효한 페이지 번호를 입력하세요.'));
        }
    };

    // 정렬 핸들러: 같은 컬럼 클릭 시 내림차순 → 오름차순 → 원상복구
    const handleSort = (key) => {
        setSortConfig(prev => {
            if (prev.key !== key) {
                return { key, order: 'desc' };
            } else {
                if (prev.order === 'desc') return { key, order: 'asc' };
                if (prev.order === 'asc') return { key: null, order: null };
                return { key, order: 'desc' };
            }
        });
    };

    const totalMappingCount = mappingSummaryList.filter(item =>
        parseInt(item.sampleName.charAt(2), 10) === activeTab
    ).length;

    const selectedFilesCount = selectedFiles.length;

    // 🔸 SheetJS(utils, writeFile) import는 더 이상 이 함수에서 필요 없음
    //    (서버가 xlsx를 만들어 내려주므로 프론트는 파일만 저장)

    const handleDownloadCNV = async () => {
        if (selectedFiles.length === 0) {
            alert(t("다운로드할 샘플을 선택하세요."));
            return;
        }

        setIsDownloadingCNV(true);

        try {
            const response = await fetch("/api/downloadCNV", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ files: selectedFiles }),
            });

            // 🔸 서버가 데이터 없음(404) 등으로 JSON을 준 경우 처리
            const contentType = response.headers.get("Content-Type") || "";
            if (!response.ok) {
                // JSON 에러 응답이면 메시지 파싱
                if (contentType.includes("application/json")) {
                    const errData = await response.json();
                    if (response.status === 404 && errData.missingSamples) {
                        alert(t("다운로드할 데이터가 없습니다."));
                    } else {
                        throw new Error(errData.error || "데이터를 가져오는 데 실패했습니다.");
                    }
                    return;
                }
                throw new Error("데이터를 가져오는 데 실패했습니다.");
            }

            // 🔸 정상 응답: xlsx 파일(blob)을 그대로 받아 저장
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = "CNV_Data.xlsx";
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);

            // 🔸 누락 샘플 정보는 응답 헤더(X-Missing-Samples)에서 읽어 처리
            const missingHeader = response.headers.get("X-Missing-Samples");
            if (missingHeader) {
                let missingSamples = [];
                try {
                    missingSamples = JSON.parse(decodeURIComponent(missingHeader));
                } catch (e) {
                    missingSamples = [];
                }
                if (missingSamples.length > 0) {
                    setTimeout(() => {
                        alert(`${t("데이터가 존재하지 않는 샘플:")}\n${missingSamples.join(", ")}`);
                    }, 500);
                }
            }
        } catch (error) {
            console.error("다운로드 실패:", error);
            alert(t("다운로드 중 오류가 발생했습니다."));
        } finally {
            setIsDownloadingCNV(false);
        }
    };

    const handleDownloadMutation = async (mutationType = "somatic") => {
        if (selectedFiles.length === 0) {
            alert(t("다운로드할 샘플을 선택하세요."));
            return;
        }

        // 타입별로 상태 분리 (UI 문구/disabled 제어용)
        const setDownloading =
            mutationType === "germline" ? setIsDownloadingGermline : setIsDownloadingMutation;

        setDownloading(true);

        const controller = new AbortController();
        const timeout = setTimeout(() => {
            controller.abort();
        }, 600000); // 10분

        try {
            const response = await fetch("/api/downloadMutation", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    files: selectedFiles,
                    mutationType, // ✅ 여기만 바뀜
                }),
                signal: controller.signal,
            });

            if (response.status === 204) {
                const missingHeader = response.headers.get("x-missing-samples");
                if (missingHeader) {
                    const missingSamples = JSON.parse(missingHeader);
                    alert(`${t('데이터가 존재하지 않는 샘플:')}\n${missingSamples.join(", ")}`);
                } else {
                    alert(t("다운로드할 데이터가 없습니다."));
                }
                return;
            }

            if (!response.ok) {
                throw new Error("다운로드 실패");
            }

            const blob = await response.blob();

            // ✅ 파일명도 타입에 따라 다르게
            const fileName = mutationType === "germline"
                ? "Germline_Mutation_Data.tsv"
                : "Somatic_Mutation_Data.tsv";

            saveAs(blob, fileName);

            const missingHeader = response.headers.get("x-missing-samples");
            if (missingHeader) {
                const missingSamples = JSON.parse(missingHeader);
                if (missingSamples.length > 0) {
                    setTimeout(() => {
                        alert(`${t('데이터가 존재하지 않는 샘플:')}\n${missingSamples.join(", ")}`);
                    }, 500);
                }
            }

        } catch (error) {
            console.error("다운로드 오류:", error);
            alert(t("다운로드 중 오류가 발생했습니다."));
        } finally {
            clearTimeout(timeout);
            setDownloading(false);
        }
    };

    const handleDownloadPurity = async () => {
        if (selectedFiles.length === 0) {
            alert(t("다운로드할 샘플을 선택하세요."));
            return;
        }

        setIsDownloadingPurity(true); // 상태 설정 (스피너 등)

        const controller = new AbortController();
        const timeout = setTimeout(() => {
            controller.abort();
        }, 600000); // 10분

        try {
            const response = await fetch("/api/downloadPurity", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ files: selectedFiles }),
                signal: controller.signal,
            });

            clearTimeout(timeout);

            if (!response.ok) {
                const errText = await response.text();
                throw new Error(errText || "다운로드 실패");
            }

            const result = await response.json();

            if (!result.purityData || result.purityData.length === 0) {
                alert(t("다운로드할 데이터가 없습니다."));
                return;
            }

            // 엑셀 파일 생성
            const wb = utils.book_new();
            const ws = utils.json_to_sheet(result.purityData);
            utils.book_append_sheet(wb, ws, "Purity");
            writeFile(wb, "Purity_Data.xlsx");

            // 누락 샘플 알림
            if (result.missingSamples && result.missingSamples.length > 0) {
                setTimeout(() => {
                    alert(`${t('데이터가 존재하지 않는 샘플:')}\n${result.missingSamples.join(", ")}`);
                }, 500);
            }

        } catch (error) {
            console.error("다운로드 오류:", error);
            alert(t("다운로드 중 오류가 발생했습니다."));
        } finally {
            setIsDownloadingPurity(false);
        }
    };

    // 정렬 헤더 셀(상단 커스텀 헤더에서 사용)
    const renderTopHeader = (label, key) => (
        <div
            type="button"
            className={styles.headerBtn}
            onClick={() => handleSort(key)}
            aria-pressed={sortConfig.key === key}
        >
            <span className={styles.headerFont}>{t(label)}</span>
            {sortConfig.key === key && (
                <span className={styles.sortChip} aria-hidden>
                    <img
                        src={sortConfig.order === 'asc' ? upArrowGray : downArrowGray}
                        alt=""
                        className={styles.sortIcon}
                    />
                </span>
            )}
        </div>
    );

    return (
        <div className={styles.wesContent}>
            <div className={styles.WESContentTitle}>{t('Summary List')} : WES</div>
            <div className={styles.select}>
                <div className={styles.keywordFilters}>
                    <label className={`${styles.checkBoxLabel} ${keywordFilters.all ? styles.active : ''}`}>
                        <input
                            className={styles.inputCheckBox}
                            type="checkbox"
                            checked={keywordFilters.all}
                            onChange={() => handleKeywordFilterChange('all')}
                        />
                        {t('전체보기')}
                    </label>
                    <label className={`${styles.checkBoxLabel} ${keywordFilters.NT ? styles.active : ''}`}>
                        <input
                            className={styles.inputCheckBox}
                            type="checkbox"
                            checked={keywordFilters.NT}
                            onChange={() => handleKeywordFilterChange('NT')}
                        />
                        NT
                    </label>
                    <label className={`${styles.checkBoxLabel} ${keywordFilters.TT ? styles.active : ''}`}>
                        <input
                            className={styles.inputCheckBox}
                            type="checkbox"
                            checked={keywordFilters.TT}
                            onChange={() => handleKeywordFilterChange('TT')}
                        />
                        TT
                    </label>
                    <label className={`${styles.checkBoxLabel} ${keywordFilters.NO ? styles.active : ''}`}>
                        <input
                            className={styles.inputCheckBox}
                            type="checkbox"
                            checked={keywordFilters.NO}
                            onChange={() => handleKeywordFilterChange('NO')}
                        />
                        NO
                    </label>
                    <label className={`${styles.checkBoxLabel} ${keywordFilters.TO ? styles.active : ''}`}>
                        <input
                            className={styles.inputCheckBox}
                            type="checkbox"
                            checked={keywordFilters.TO}
                            onChange={() => handleKeywordFilterChange('TO')}
                        />
                        TO
                    </label>
                </div>
            </div>

            <div className={styles.wesHeadGrid}>
                <div>
                    <div className={styles.smallTitle}>
                        {t('전체 샘플')}: {totalMappingCount}
                    </div>
                    <div className={styles.smallTitle}>
                        {t('선택된 샘플')}: {selectedFilesCount}
                    </div>
                </div>
                <div>
                    <input
                        type="text"
                        placeholder={t('샘플 이름 또는 수주번호로 필터링')}
                        value={filterText}
                        onChange={(e) => setFilterText(e.target.value)}
                        className={styles.filterInput}
                        style={{
                            backgroundImage: `url(${filterImage})`,
                            backgroundRepeat: 'no-repeat',
                            backgroundPosition: '15px center',
                            backgroundSize: 'auto 70%',
                            paddingLeft: '35px',
                        }}
                    />
                </div>
                <div>
                    <div onClick={() => handleDownloadMappingSummary('all')} className={styles.summaryDownloadButton}>
                        {t('전체 Mapping Summary 다운로드')}
                    </div>
                </div>
                <div>
                    <div onClick={() => handleDownloadMappingSummary('selected')} className={styles.summaryDownloadButton}>
                        {t('선택된 Mapping Summary 다운로드')}
                    </div>
                </div>
            </div>

            <div className={styles.topLine} />
            <div className={styles.dataGrid}>
                <div className={styles.dataGridLeft}>
                    <div onClick={() => setShowUploadModal(true)} className={styles.uploadButton}>
                        <img src={uploadIcon} className={styles.uploadIcon} alt="upload" />
                        {t('파일 업로드')}
                    </div>
                    {Object.entries(TABS).map(([key, label]) => (
                        <div
                            key={key}
                            className={`${styles.tabButton} ${activeTab === parseInt(key, 10) ? styles.active : ''}`}
                            onClick={() => handleTabChange(parseInt(key, 10))}
                        >
                            {t(label)}
                        </div>
                    ))}
                </div>
                <div className={styles.dataGridMid} />
                <div className={styles.dataGridRight}>
                    <div className={styles.tableHeader}>
                        <div className={styles.centerCell}>
                            <div
                                className={`${styles.radioDot} ${isAllSelected ? styles.on : ''}`}
                                role="checkbox"
                                aria-checked={isAllSelected}
                                tabIndex={0}
                                onClick={handleSelectAll}
                                onKeyDown={(e) => {
                                    if (e.key === ' ' || e.key === 'Enter') {
                                        e.preventDefault();
                                        handleSelectAll();
                                    }
                                }}
                            />
                        </div>
                        {renderTopHeader('수주번호', 'orderNumber')}
                        {renderTopHeader('Sample', 'sampleName')}
                        {renderTopHeader('Status', 'status')}
                        {renderTopHeader('Total Read', 'totalRead')}
                        {renderTopHeader('Mapped Read', 'mappedRead')}
                        {renderTopHeader('Mapping Rate (%)', 'percent')}
                        {renderTopHeader('MSI (%)', 'msiPercent')}
                        <div className={styles.headerBtn}>
                            <span className={styles.headerFont}>{t('Report')}</span>
                        </div>
                    </div>
                    <div className={styles.tableHeaderBottom} />
                    <div className={styles.tableBody}>
                        {currentItems.map(item => {
                            const isSelected = selectedFiles.includes(item.sampleName);
                            return (
                                <div
                                    className={`${styles.tableContent} ${isSelected ? styles.selectedRow : ''}`}
                                    key={item.sampleName}
                                    onClick={() => handleCheckboxChange(item.sampleName)}   // 행 클릭 = 체크박스 토글
                                    role="row"
                                    aria-selected={isSelected}
                                >
                                    <div className={styles.centerCell}>
                                        <div
                                            className={`${styles.radioDot} ${isSelected ? styles.on : ''}`}
                                            role="checkbox"
                                            aria-checked={isSelected}
                                            aria-label={`${item.sampleName} ${t('선택')}`}
                                            tabIndex={0}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleCheckboxChange(item.sampleName);
                                            }}
                                            onKeyDown={(e) => {
                                                if (e.key === ' ' || e.key === 'Enter') {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    handleCheckboxChange(item.sampleName);
                                                }
                                            }}
                                        />
                                    </div>

                                    <div className={styles.centerCell}>{item.orderNumber}</div>

                                    {/* 샘플명을 클릭하면 상세 보기 (행 선택 토글은 막기) */}
                                    <div
                                        className={`${styles.centerCell} ${styles.sampleLink}`}
                                        role="button"
                                        tabIndex={0}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleSampleClick(item.sampleName);
                                        }}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                handleSampleClick(item.sampleName);
                                            }
                                        }}
                                        title={item.sampleName}
                                    >
                                        {item.sampleName}
                                    </div>

                                    <div className={styles.centerCell}>{item.status}</div>
                                    <div className={styles.centerCell}>
                                        {item.totalRead != null ? Number(item.totalRead).toLocaleString() : ''}
                                    </div>
                                    <div className={styles.centerCell}>
                                        {item.mappedRead != null ? Number(item.mappedRead).toLocaleString() : ''}
                                    </div>
                                    <div className={styles.centerCell}>
                                        {item.percent != null && item.percent !== '' && !isNaN(Number(item.percent))
                                            ? Number(item.percent).toFixed(2)
                                            : '-'} {/* 값이 없거나 이상하면 '-' 출력 */}
                                    </div>
                                    <div className={styles.centerCell}>{item.msiPercent}{Number(item.msiPercent) >= 10 && (
                                        <img
                                            src={upTriangleRed}
                                            alt="MSI high"
                                            className={styles.msiIcon} // 선택: 크기/여백용
                                        />
                                    )}</div>
                                    <div className={styles.centerCell}>
                                        {item.sampleName &&
                                            item.sampleName.length >= 8 &&
                                            item.sampleName.charAt(7).toUpperCase() !== 'N' && (
                                                <span
                                                    onClick={(e) => {
                                                        e.stopPropagation(); // 로우 선택(체크박스) 이벤트와 겹치지 않게 방지
                                                        handleOpenReport(item.sampleName);
                                                    }}
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    🔍
                                                </span>
                                            )}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
            <div className={styles.buttonGroup}>
                <div className={styles.mappingSummaryContainer}>
                    <div className={styles.paginationBar}>
                        {/* 맨 앞으로 */}
                        <button
                            type="button"
                            className={`${styles.pagerBtn} ${currentPage === 1 ? styles.pagerBtnDisabled : ''}`}
                            onClick={() => currentPage > 1 && setCurrentPage(1)}
                            disabled={currentPage === 1}
                            aria-label={t('첫 페이지')}
                            title={t('첫 페이지')}
                        >
                            «
                        </button>

                        {/* 한 페이지 뒤로 */}
                        <button
                            type="button"
                            className={`${styles.pagerBtn} ${currentPage === 1 ? styles.pagerBtnDisabled : ''}`}
                            onClick={() => currentPage > 1 && setCurrentPage(currentPage - 1)}
                            disabled={currentPage === 1}
                            aria-label={t('이전 페이지')}
                            title={t('이전 페이지')}
                        >
                            ‹
                        </button>

                        {/* 현재 페이지 / 전체 페이지 */}
                        <span className={styles.pageStat}>
                            {currentPage} / {totalPages}
                        </span>

                        {/* 한 페이지 앞으로 */}
                        <button
                            type="button"
                            className={`${styles.pagerBtn} ${currentPage === totalPages ? styles.pagerBtnDisabled : ''}`}
                            onClick={() => currentPage < totalPages && setCurrentPage(currentPage + 1)}
                            disabled={currentPage === totalPages}
                            aria-label={t('다음 페이지')}
                            title={t('다음 페이지')}
                        >
                            ›
                        </button>

                        {/* 맨 뒤로 */}
                        <button
                            type="button"
                            className={`${styles.pagerBtn} ${currentPage === totalPages ? styles.pagerBtnDisabled : ''}`}
                            onClick={() => currentPage < totalPages && setCurrentPage(totalPages)}
                            disabled={currentPage === totalPages}
                            aria-label={t('마지막 페이지')}
                            title={t('마지막 페이지')}
                        >
                            »
                        </button>

                        {/* 점프 입력창: "페이지번호 + Enter" */}
                        <input
                            type="number"
                            className={styles.pageJumpInput}
                            placeholder={t('페이지 번호 + Enter')}
                            value={currentPageInput}
                            onChange={(e) => setCurrentPageInput(e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    const v = parseInt(currentPageInput, 10);
                                    if (!isNaN(v)) {
                                        const clamped = Math.min(Math.max(v, 1), totalPages || 1);
                                        setCurrentPage(clamped);
                                    }
                                }
                            }}
                            aria-label={t('페이지 번호 입력')}
                            title={t('페이지 번호 입력 후 Enter')}
                        />
                    </div>
                </div>

                <div className={styles.analysisGroup}>
                    <button
                        onClick={handleDownloadCNV}
                        disabled={isDownloadingCNV || isDownloadingMutation || isDownloadingPurity || isDownloadingGermline}
                        className={isDownloadingCNV ? styles.disabledButton : ''}
                    >
                        {isDownloadingCNV ? t('다운로드 중...') : t('CNV 다운로드')}
                    </button>
                    <button
                        onClick={() => handleDownloadMutation("somatic")}
                        disabled={isDownloadingMutation || isDownloadingCNV || isDownloadingPurity || isDownloadingGermline}
                        className={isDownloadingMutation ? styles.disabledButton : ''}
                    >
                        {isDownloadingMutation ? t('다운로드 중...') : t('Mutation 다운로드')}
                    </button>
                    {showGermlineButton && (
                        <button
                            onClick={() => handleDownloadMutation("germline")}
                            disabled={isDownloadingCNV || isDownloadingMutation || isDownloadingPurity || isDownloadingGermline}
                            className={isDownloadingGermline ? styles.disabledButton : ""}
                        >
                            {isDownloadingGermline ? t("다운로드 중...") : t("Germline 다운로드")}
                        </button>
                    )}
                    <button
                        onClick={handleDownloadPurity}
                        disabled={isDownloadingPurity || isDownloadingMutation || isDownloadingCNV || isDownloadingGermline}
                        className={isDownloadingPurity ? styles.disabledButton : ''}
                    >
                        {isDownloadingPurity ? t('다운로드 중...') : t('Purity 다운로드')}
                    </button>
                </div>
            </div>


            {
                showUploadModal && (
                    <MultiLargeFileUploads onClose={() => setShowUploadModal(false)} type={'WES'} />
                )
            }
            {showPairedModal && (
                <>
                    <div className={styles.overlay} onClick={() => setShowPairedModal(false)} />
                    <div className={styles.pairedModal}>
                        <PairedSampleList
                            sampleName={pairedSample}
                            onClose={() => setShowPairedModal(false)}
                        />
                    </div>
                </>
            )}
            <ReportModal
                isOpen={isReportModalOpen}
                onClose={() => setIsReportModalOpen(false)}
                sampleName={selectedReportSample}
                reportType="WES"
            />
        </div >
    );
}

export default WESContent;